import { render, staticRenderFns } from "./BankTransferRadioInput.vue?vue&type=template&id=9683945e&scoped=true&"
import script from "./BankTransferRadioInput.vue?vue&type=script&lang=js&"
export * from "./BankTransferRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9683945e",
  null
  
)

export default component.exports